import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { AuthStateService } from '../services/auth-state.service';
import { OnboardingRouteService } from '../services/onboarding-route.service';
import { isClientRole } from '../utils/role.util';

export const authGuardModule: CanActivateFn = async () => {
  const authState = inject(AuthStateService);
  const onboardingRoute = inject(OnboardingRouteService);
  const router = inject(Router);

  const authenticated = await firstValueFrom(authState.ensureAuthenticated());
  if (!authenticated) {
    return router.createUrlTree(['/login']);
  }

  const session = authState.getSession();
  if (session?.postLoginState === 'ApplicationUnderReview') {
    return router.createUrlTree(['/application-review']);
  }
  if (session?.postLoginState === 'OnboardingIncomplete' && session.applicationNumber) {
    const ref = await onboardingRoute.ensureEncryptedRef(session.applicationNumber);
    if (ref) {
      return router.createUrlTree(['/onboarding', ref]);
    }
  }
  if (isClientRole(session?.roleId)) {
    return router.createUrlTree(['/client']);
  }

  return true;
};
